import { P1Medium as P1MediumStyle } from 'theme/typography';
import { Text, TextProps } from '@mantine/core';
import mergeTextSx from 'components/typography/merge-text-sx';

/**
 * Applies the P1Medium typography style.
 */
export default function P1Medium({ sx, ...props }: TextProps) {
  return <Text {...props} sx={mergeTextSx(P1MediumStyle, sx)} />;
}
